import axios from 'axios';
import { BasicInfoModel } from 'src/models/customer/basicInfoModel';
import { enqueueSnackbar } from 'notistack';
import { API_url } from '../api.setup';

const API_Controller = '/customers';

export const BasicInfoService = {
  findData: async (data) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/find?mobileNumber=${data}`
      );

      return response.data as BasicInfoModel;
    } catch (error) {
      enqueueSnackbar(`No data linked by this number`, {
        variant: 'error'
      });
      // throw error;
    }
  },

  addData: async (customerToUpdate: any) => {
    try {
      const reqModel = {
        id: customerToUpdate.id,
        firstAndMiddleName: customerToUpdate.firstAndMiddleName,
        lastName: customerToUpdate.lastName,
        cityId: customerToUpdate.city,
        areaId: customerToUpdate.area,
        mobileNumber: customerToUpdate.mobileNumber,
        emailId: customerToUpdate.emailId,
        birthday: customerToUpdate.birthday || '1900-01-01',
        anniversary: customerToUpdate.anniversary || '1900-01-01',
        contactNumber1: customerToUpdate.contactNumber1,
        contactNumber2: customerToUpdate.contactNumber2,
        isActive: customerToUpdate.isActive
      };

      const response = await axios.post(
        `${API_url}${API_Controller}`,
        reqModel
      );

      enqueueSnackbar(
        `Customer ${customerToUpdate.firstAndMiddleName} Added Successfully`,
        {
          variant: 'success'
        }
      );
      return response.data as BasicInfoModel;
    } catch (error) {
      enqueueSnackbar(
        `Customer ${customerToUpdate.firstAndMiddleName} Added Unsuccessfully`,
        {
          variant: 'error'
        }
      );
      console.error(error);
      throw error;
    }
  },

  editData: async (editedData) => {
    try {
      const reqModel = {
        id: editedData.id,
        firstAndMiddleName: editedData.firstAndMiddleName,
        lastName: editedData.lastName,
        cityId: editedData.city,
        areaId: editedData.area,
        mobileNumber: editedData.mobileNumber,
        emailId: editedData.emailId,
        birthday: editedData.birthday,
        anniversary: editedData.anniversary,
        contactNumber1: editedData.contactNumber1,
        contactNumber2: editedData.contactNumber2,
        isActive: editedData.isActive
      };

      const response = await axios.put(
        `${API_url}${API_Controller}/update`,
        reqModel
      );
      const updatedArea = {
        ...response.data,
        city: { name: editedData.firstAndMiddleName }
      };
      enqueueSnackbar(
        `Customer " ${editedData.firstAndMiddleName} " Edited Successfully`,
        {
          variant: 'success'
        }
      );

      return updatedArea as BasicInfoModel;
    } catch (error) {
      enqueueSnackbar(
        `Customer " ${editedData.firstAndMiddleName} " Edited Unsuccessfully`,
        {
          variant: 'error'
        }
      );
      throw error;
    }
  },

  findCustomers: async (searchText: string) => {
  try {
    const response = await axios.get(
      `${API_url}${API_Controller}/FindCustomer?searchText=${searchText}`
    );
    return response.data; // array of customers
  } catch (error) {
    enqueueSnackbar(`No customers found`, { variant: 'error' });
    return [];
  }
},

getCustomerById: async (id: number) => {
  try {
    const response = await axios.get(
      `${API_url}${API_Controller}/get?id=${id}`
    );
    return response.data;
  } catch (error) {
    enqueueSnackbar(`Failed to load customer details`, { variant: 'error' });
    throw error;
  }
}

};
